export const SvgDataSets = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 8.5C17.5228 8.5 22 7.15685 22 5.5C22 3.84315 17.5228 2.5 12 2.5C6.47715 2.5 2 3.84315 2 5.5C2 7.15685 6.47715 8.5 12 8.5Z"
      fill="#7C68FB"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.38545 7.75C3.30939 8.2997 2 9.104 2 10C2 11.6568 6.47715 13 12 13C17.5229 13 22 11.6568 22 10C22 9.104 20.6906 8.2997 18.6145 7.75C16.8517 8.21675 14.5361 8.5 12 8.5C9.4639 8.5 7.14825 8.21675 5.38545 7.75Z"
      fill="#7C68FB"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.38545 12.25C3.30939 12.7997 2 13.604 2 14.5C2 16.1568 6.47715 17.5 12 17.5C17.5229 17.5 22 16.1568 22 14.5C22 13.604 20.6906 12.7997 18.6145 12.25C16.8517 12.7167 14.5361 13 12 13C9.4639 13 7.14825 12.7167 5.38545 12.25Z"
      fill="#7C68FB"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.38545 16.75C3.30939 17.2997 2 18.104 2 19C2 20.6568 6.47715 22 12 22C17.5229 22 22 20.6568 22 19C22 18.104 20.6906 17.2997 18.6145 16.75C16.8517 17.2167 14.5361 17.5 12 17.5C9.4639 17.5 7.14825 17.2167 5.38545 16.75Z"
      fill="#7C68FB"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
